import React from "react";
import {CardBody, CardText, CardTitle, Row} from "reactstrap";

export const InventoryReportsCard = ({data}) => {
  const {customer, site, location, action, serial, organization, user_by, event_at} =
    data;
  return (
    <Row>
      <div className="col-12 mt-3">
        <div style={{display: "flex", flex: "1 1 auto"}}>
          <CardBody>
            <CardText style={{display: "flex", alignItems: "baseline"}}>
              Serial Number : {serial}
            </CardText>
            <CardText style={{display: "flex", alignItems: "baseline"}}>
              Organization : {organization}
            </CardText>
            <CardTitle tag="h3">
              <CardText>Customer : {customer ?? "-"}</CardText>
            </CardTitle>
            <CardText style={{display: "flex", alignItems: "baseline"}}>
              Site : {site ?? "-"}
            </CardText>
            <CardText style={{display: "flex", alignItems: "baseline"}}>
              Location : {location ?? "-"}
            </CardText>
            <CardText style={{display: "flex", alignItems: "baseline"}}>
              Action : {action}
            </CardText>
            <CardText style={{display: "flex", alignItems: "baseline"}}>
              User By : {user_by}
            </CardText>
            <CardText style={{display: "flex", alignItems: "baseline"}}>
              Event At : {event_at}
            </CardText>
          </CardBody>
        </div>
      </div>
    </Row>
  );
};
